export default __webpack_public_path__ + "static/media/spanish.5fa58ab1.mp4";